import axios from "axios";

export default class maintenanceChecker {
  /**
   * This guy checks a maintenance-mode endpoint on a heartbeat.
   *
   * If maintenance-mode is enabled, it will call the onServiceDownCb callback
   * If maintenance-mode is disabled, it will call the onServiceUpCb callback
   *
   * @param {String} url
   * @param {Number} secondsToCheck
   * @param {Function} onServiceDownCb
   * @param {onServiceUpCb} onServiceUpCb
   */
  constructor(url, secondsToCheck = 60, onServiceDownCb, onServiceUpCb) {
    this.url = url;
    this.msToCheck = secondsToCheck * 1000;
    this.httpClient = axios.create();
    if (typeof onServiceDownCb !== "function") {
      this.onServiceDownCb = () => {
        console.log("service down");
      };
    } else {
      this.onServiceDownCb = function() {
        onServiceDownCb();
      };
    }
    if (typeof onServiceUpCb !== "function") {
      this.onServiceUpCb = () => {
        console.log("service up");
      };
    } else {
      this.onServiceUpCb = function() {
        onServiceUpCb();
      };
    }

    this.fnCheckInterval = null;
  }

  doCheck() {
    this.checkApi(this.url)
      .then(val => this.onSuccess(val))
      .catch(err => this.onError(err));
  }

  startChecking() {
    this.doCheck();
    this.fnCheckInterval = setInterval(() => {
      this.doCheck();
    }, this.msToCheck);
  }

  stopChecking() {
    if (this.fnCheckInterval !== null) {
      clearInterval(this.fnCheckInterval);
      this.fnCheckInterval = null;
    }
  }

  onSuccess(res) {
    // the maintenance-mode endpoint will return:

    //  200 - maintenance-mode enabled
    //  204 - maintenance-mode not enabled (no-content)

    // 200 codes are preferred over 4xx/5xx since
    // these are always reported as errors in the console
    if (res.status) {
      if (res.status === 200) {
        this.onServiceDownCb();
      }
      if (res.status === 204) {
        this.onServiceUpCb();
      }
    }
  }

  onError(err) {
    // we don't actually need to handle this scenario
    console.log(err);
  }

  checkApi(url) {
    return new Promise(() => {
      this.httpClient
        .get(url)
        .then(res => this.onSuccess(res))
        .catch(err => this.onError(err));
    });
  }
}
